import { render, staticRenderFns } from "./paciente.vue?vue&type=template&id=f3494b84&scoped=true"
import script from "./paciente.vue?vue&type=script&lang=js"
export * from "./paciente.vue?vue&type=script&lang=js"
import style0 from "./paciente.vue?vue&type=style&index=0&id=f3494b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3494b84",
  null
  
)

export default component.exports